import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button, Text, Heading4 } from '@blueprint/ui';

export const Content = styled('div')(css`
    text-align: center;
`);

export const StyledHeading = styled(Heading4)(
    (props) => css`
        margin-bottom: ${props.theme.spacing['24px']};
    `
);

export const StyledText = styled(Text)(
    (props) => css`
        height: 4.375rem;
        margin-bottom: ${props.theme.spacing['24px']};
    `
);

export const StyledButton = styled(Button)(
    (props) => css`
        display: block;
        width: 100%;
        margin-bottom: ${props.theme.spacing['24px']};
    `
);

export const StyledLinkContainer = styled('div')(
    (props) => css`
        margin-bottom: ${props.theme.spacing['24px']};
    `
);

export const StyledImg = styled('img')(
    (props) => css`
        display: block;
        margin: 0 auto ${props.theme.spacing['32px']} auto;
    `
);
